import React from 'react';
import EventArchive from './EventArchive';
import { Link } from 'react-router-dom';

function About() {
  document.title = 'Unieros About Our Mission';
  const videoId = 'YsxVHJUaBuA';
    return (
      <div className="container">

        <h1 className="display-1 page-title">About Unieros</h1>
        <div className="row">
        <p class="lead text-body-secondary">Welcome to Unieros, an event company focused on celebrating our world's diverse cultures. Our name combines "Universal" and Eros, the Greek god of love, to express our mission of promoting "One Love" through understanding and connection across cultures.
          </p>
        </div>
      
          <div className="embed-responsive embed-responsive-16by9">
        <iframe
          className="embed-responsive-item mb-3"
          src={`https://www.youtube.com/embed/${videoId}`}
          title="Unieros mission and purpose"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
      


<div className='testimonial d-block w-100'><p className="testimonial-content">Unieros leverages the latest technologies to ensure that the cultural dialogue grows richer.</p><span className="small"><a href="https://chicago.suntimes.com/news/2012/4/13/18534100/ease-of-making-connections">Chicago Sun-Times </a></span></div>
<div className="about-section">
  <h2>Our Story</h2>
  <p>Unieros, founder Christine Brown Clayton (nee Christine Brown), established Unieros in 2004 as a website to celebrate culture and diversity. The sole purpose was to connect people across cultures in social events. Since then Unieros, has expanded to multicultural events in cities like Chicago and Savannah, Georgia.</p>
<p>In 2022 Unieros brought the first <a href="https://www.wtoc.com/2022/08/07/jamaican-independence-celebrated-savannah/">Jamaican Independence celebration to Savannah, Georgia </a>to connect the growing Jamaican diaspora in South East Georgia. </p>
</div>

<div className="about-section">
  <h2>Our Mission</h2>
  
  <p>Our mission is to promote "One Love" through understanding and connection across cultures. We believe that by sharing our cultures, we can build a more peaceful and loving world.</p>
  <h5>We are a global community in local places.</h5>
  <p>Unieros multicultural events include picnics, dinners, concerts, media are designed for everyone, ensuring that anyone can participate and enjoy the rich cultural experiences we offer.</p>
<div >


<div>
<img sr="" className="img-fluid"/>
</div>
<div>
<p>We are passionate about uniting people of different backgrounds and helping them learn about each other's traditions. Our events include tasty food tours, ethnic dining experiences, colorful multicultural festivals, and exciting world music shows. </p>
</div>
<div className="mb-4">
  <EventArchive />
</div>

<p><Link to="/contact" className="btn btn-unieros">Join us</Link></p>

</div>
</div>
</div>

    );
  }

  export default About;